
<div class="sequence-validator">

  <div class="validator-heading">
    <div class="validator-heading-icon">
      <i class="pi pi-calendar-check"></i>
    </div>

    <div>
      <h3>Verifica turni di reperibilità</h3>
      <p>
        Controlla le settimane generate e apporta eventuali
        modifiche prima della conferma.
      </p>
    </div>
  </div>

  <div class="validator-content">
    <ng-container *ngFor="let period of periods; index as indexP">
      <div class="validator-week">

        <div class="week-header">
          <div class="week-title">
            <span class="week-number">{{ indexP + 1 }}</span>

            <div>
              <h3>{{ indexP + 1 }}° Settimana di reperibilità</h3>
              <p>Verifica le date e le giornate previste.</p>
            </div>
          </div>

          <p-button
            icon="pi pi-trash"
            severity="danger"
            styleClass="p-button-outlined week-delete-button"
            pTooltip="Elimina settimana"
            (onClick)="periods.splice(indexP, 1)"
          ></p-button>
        </div>

        <div class="week-dates">
          <div class="date-field">
            <label>Data inizio</label>
            <p-calendar
              [dateFormat]="'DD, dd MM yy'"
              [(ngModel)]="period.startDate"
            ></p-calendar>
          </div>

          <div class="date-field">
            <label>Data fine</label>
            <p-calendar
              [dateFormat]="'DD, dd MM yy'"
              [(ngModel)]="period.endDate"
            ></p-calendar>
          </div>
        </div>

        <div class="validator-days">
          <ng-container *ngFor="let unit of period.units; index as indexU">
            <div
              class="validator-day"
              [class.validator-day-inactive]="!unit.isActive"
            >
              <div class="validator-day-heading">
                <p-toggleButton
                  [(ngModel)]="unit.isActive"
                  [onLabel]="(indexU + 1) + '° Giornata di reperibilità'"
                  [offLabel]="(indexU + 1) + '° Giornata di reperibilità - Servizio non attivo'"
                ></p-toggleButton>
              </div>

              <ng-container *ngIf="unit.isActive">
                <div class="day-date-field">
                  <label>Data della giornata</label>
                  <p-calendar
                    [dateFormat]="'DD, dd MM yy'"
                    [(ngModel)]="unit.unitDate"
                  ></p-calendar>
                </div>

                <div class="day-times">
                  <div class="day-times-heading">
                    <i class="pi pi-clock"></i>
                    <h4>Fasce orarie</h4>
                  </div>

                  <ng-container *ngIf="unit.times.length === 0">
                    <p-button
                      label="Aggiungi fascia oraria"
                      icon="pi pi-plus"
                      styleClass="p-button-outlined add-time-button"
                      (onClick)="unit.times.splice(0, 0, {
                        startTime: '08:00',
                        endTime: '20:00',
                        delegate: ''
                      })"
                    ></p-button>
                  </ng-container>

                  <ng-container *ngFor="let time of unit.times; index as indexT">
                    <div class="validator-time-row">
                      <div class="delegate-field">
                        <label>Reperibile</label>
                        <input
                          pInputText
                          type="text"
                          [(ngModel)]="time.delegate"
                        />
                      </div>

                      <div class="time-field">
                        <label>Dalle ore</label>
                        <p-inputMask
                          mask="99:99"
                          [(ngModel)]="time.startTime"
                          placeholder="Orario inizio"
                        ></p-inputMask>
                      </div>

                      <div class="time-field">
                        <label>Alle ore</label>
                        <p-inputMask
                          mask="99:99"
                          [(ngModel)]="time.endTime"
                          placeholder="Orario fine"
                        ></p-inputMask>
                      </div>

                      <div class="time-actions">
                        <p-button
                          icon="pi pi-plus"
                          styleClass="p-button-outlined"
                          pTooltip="Aggiungi fascia"
                          (onClick)="unit.times.splice(indexT + 1, 0, {
                            startTime: time.endTime,
                            endTime: time.endTime,
                            delegate: ''
                          })"
                        ></p-button>

                        <p-button
                          icon="pi pi-times"
                          severity="danger"
                          styleClass="p-button-outlined"
                          pTooltip="Rimuovi fascia"
                          (onClick)="unit.times.splice(indexT, 1)"
                        ></p-button>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </div>

      </div>
    </ng-container>

    <div *ngIf="periods.length === 0" class="validator-empty">
      <i class="pi pi-calendar-times"></i>
      <h4>Nessuna settimana presente</h4>
      <p>Non ci sono turni da verificare.</p>
    </div>
  </div>

  <div class="validator-actions">
    <p-button
      icon="pi pi-times"
      label="Annulla"
      styleClass="p-button-outlined p-button-secondary"
      (onClick)="cancel()"
    ></p-button>

    <p-button
      icon="pi pi-check"
      label="Conferma"
      (onClick)="confirm()"
    ></p-button>
  </div>

</div>
